export default {
  addOnModal: '{{addOn}} modal',
  applyPromoCode: 'Apply promo code',
  bookExperiencePanel: 'Book experience panel',
  calendarIcon: 'Calendar icon',
  closeModal: 'Close modal',
  coverImageForResource: 'Cover image for {{title}} experiences',
  decreaseAddOnAmount: 'Decrease {{addOn}} selected',
  decreasePriceTierTickets: 'Decrease {{priceTier}} tickets',
  deleteReservation: 'Delete {{experienceTitle}} reservation',
  downloadFilename: 'Download {{filename}}',
  editParticipantsFor: 'Edit participants for {{experienceTitle}}',
  enterPromoCode: 'Enter promo code',
  filterBy: 'Filter by {{filter}}',
  filterByDateRange: 'Filter by date range',
  gallery: 'Gallery',
  goBack: 'Back to previous page',
  hostUserIcon: 'Host user icon',
  imageOf: 'Image of {{title}}',
  increaseAddOnAmount: 'Increase {{addOn}} selected',
  increasePriceTierTickets: 'Increase {{priceTier}} tickets',
  interactiveMapAltText: 'Interactive map with selectable {{title}}',
  mediaSlides: 'Media slides',
  moreInformationAboutAddOn: 'More information about {{addOn}}',
  muteVideo: 'Mute video',
  nextPhoto: 'Next photo',
  noVideoPlayback: 'No video playback capability',
  pauseVideo: 'Pause video',
  photoOf: 'Photo of {{name}}',
  playVideo: 'Play video',
  previousPhoto: 'Previous photo',
  reserveName: `Reserve {{name}}`,
  moreFiltersAndExperiences: 'More filters and experiences',
  reserveSelectedSlot: 'Reserve selected slot',
  reviewRating: 'Review rating {{rating}} of 5',
  overallReviewRating: 'Overall review rating {{rating}} of 5',
  selectCountryCodeForPhoneNumber: 'Select country code for phone number',
  selectData: `Select {{data}}`,
  selectDate: 'Select date',
  selectParticipants: 'Select participants',
  selectSessionTime: 'Select session time',
  unmuteVideo: 'Unmute video',
  viewFullDescription: 'View full description',
  viewFullDetailsDescription: 'View full details description',
  viewShoppingCart: 'View shopping basket',
  itemsInCart: '{{count}} items in shopping basket',
  zoomIn: 'Zoom in',
  zoomOut: 'Zoom out',
  hyattBanner: 'World Of Hyatt Member Exclusive Banner',
  hyattBannerDesc:
    'Promotional banner indicating exclusive benefits and offers available to World of Hyatt loyalty programme members',
  previousSlide: 'Previous slide',
  nextSlide: 'Next slide',
  paginationBulletMessage: 'Go to slide',
  exitFullscreen: 'Exit fullscreen view',
  enterFullscreen: 'Enter fullscreen view',
  videoSlide: 'Video slide',
  imageSlide: 'Image slide',
  of: 'of',
  noDescription: 'No description',
  mediaGallery: 'Carousel - Media gallery',
  dateSelector: 'Date selector',
  nextWeek: 'Next week',
  previousWeek: 'Previous week',
  scheduleAgenda: 'Schedule agenda',
  scheduleNav: 'Schedule navigation',
  scheduleViewSelector: 'Schedule view selector',
  selectedDateAriaLabel: '{{date}}, selected',
  tapToBookExperience: 'Book {{title}}',
  bookExperienceAriaLabel: 'Book {{title}}',
  joinWaitlistAriaLabel: 'Join waitlist for {{title}}',
};
